import React from 'react';
import classes from "./Wishlist.module.css";

export const WishlistHeaderSkeleton = () => {
  return (
    <>
      <div className={classes.wishlistHeader}>
        <div className={classes.wishlistHeaderUp}>
          <div className={classes.skeletonTitle}></div>
          <div className={classes.headerButtonsContainer}>
            <div className={classes.skeletonButton}></div>
            <div className={classes.skeletonButton}></div>
          </div>
        </div>
        <div className={classes.wishlistHeaderDown}>
          <div className={classes.skeletonText}></div>
        </div>
      </div>
      <div className={classes.longHorizontalLine}></div>
    </>
  );
};

export default WishlistHeaderSkeleton;
